import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { LOGIN } from '@core/constants/RoutingsPath';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-home-video',
    templateUrl: './home-video.component.html',
    styleUrls: ['./home-video.component.scss'],
    standalone: false
})
export class HomeVideoComponent implements OnInit, AfterViewInit {
  @ViewChild('videoDesktop') videoDesktop!: ElementRef;
  @ViewChild('videoMobile') videoMobile!: ElementRef;

  loginPath = `/${LOGIN}`;
  isMobile = false;
  isLogging = false;

  ngOnInit() {
    this.getPlatform();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (
        this.videoDesktop?.nativeElement &&
        (this.videoDesktop?.nativeElement as HTMLVideoElement)?.paused
      ) {
        (this.videoDesktop.nativeElement as HTMLVideoElement).muted = true;
        (this.videoDesktop.nativeElement as HTMLVideoElement).play();
      }

      if (
        this.videoMobile?.nativeElement &&
        (this.videoMobile?.nativeElement as HTMLVideoElement)?.paused
      ) {
        (this.videoMobile.nativeElement as HTMLVideoElement).muted = true;
        (this.videoMobile.nativeElement as HTMLVideoElement).play();
      }
    }, 100);
  }

  async getPlatform() {
    if (Capacitor.isNativePlatform()) {
      this.isMobile = true;
    }
  }
}
